import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
    <carte-mariale></carte-mariale>
  `,
  styles: [`
    `]
})
export class AppComponent {
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts